import script from "./CatalogItemActions2.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogItemActions2.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogItemActions2.vue?vue&type=style&index=0&id=5929971a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5929971a"]])

export default __exports__